import axios from "../axios";

const printLayoutApi = {
  get: (companyId, invoiceTypeId) => {
    return axios.get(`/PrintLayout/${companyId}/${invoiceTypeId}`);
  },
  save: (payload) => {
    return axios.post("/PrintLayout/save", payload);
  }
};

export default printLayoutApi;
